import React, { useEffect, useState } from 'react'
import MySelect from '../../UI/form/MySelect'

const CurrencySelectMain = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
  	const [validSelect, setValidSelect] = useState(false)
	const [currencies, setCurrencies] = useState([
		{
			id: 'UAH',
			name: 'грн'
		},
		{
			id: 'USD',
			name: '$'
		},
		{
			id: 'EUR',
			name: '€'
		},
	])

	useEffect(() => {
		getUnitMeasures()
	}, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getUnitMeasures = () => {
		// getGoodTypesAllAPI().then(data => {
		// 	setGoodTypes(data)
		// }).catch(e => {
		// 	// setError(responseError(e))
		// 	console.error(responseError(e))
		// })
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
				setValidSelect(true)
			} else {
				setValidate(false)
				setValidSelect(false)
			}
		} else {
			setValidate(true)
			setValidSelect(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Валюта"
        labelId="select__unitMeasure-label"
        id='select__unitMeasure'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Валюта'
        // sx={{width: '200px'}}
        options={
			currencies && currencies.length > 0 ? 
				currencies.map(currency => {
            		return {id: currency.id, name: currency.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default CurrencySelectMain